<h1>Scholarship Application Preview for: <span class="text-orange-400">{{details?.ScholarshipName}}</span></h1>
<mat-divider></mat-divider>
<p>
    A preview of what the student will see if they are eligible for this scholarship.
    All the scholarships the student is eligible for will be listed in this format, ordered alphabetically from top to bottom.
</p>

<div class="flex flex-col items-center">
    <mat-card [class]="smallScreen === true ? 'smallScreenCard' : 'largeScreenCard'">
        <p>{{details?.Description}}</p>
        @if (details?.AdditionalQuestion != null && details?.AdditionalQuestion != '') {
        <div>
            <span class="text">Additional Question</span>
        </div>
        <div class="flex flex-col">
            @if (details?.AqHaveYesNo === true) {
            <mat-radio-group class="flex flex-start gap-[10px] mb-0" [(ngModel)]="radio">
                <mat-radio-button [value]="true" (click)="$event.preventDefault(); 
                                    resetRadio(true)" matTooltip="Click again to clear value" [matTooltipDisabled]="radio !== true">
                    Yes
                </mat-radio-button>
                <mat-radio-button [value]="false" (click)="$event.preventDefault(); 
                                    resetRadio(false)" matTooltip="Click again to clear value" [matTooltipDisabled]="radio !== false">
                    No
                </mat-radio-button>
                <mat-label>{{details?.AdditionalQuestion}}</mat-label>
            </mat-radio-group>
            }
            @else {
            <div class="w-full">{{ details?.AdditionalQuestion }}</div>
            }
            @if (details?.AqHaveText === true) {
            <mat-form-field class="w-full">
                <input matInput maxlength="7000" />
            </mat-form-field>
            }
        </div>
        }
        @if (details?.EmployeeNameReq === true) {
        <div>
            <div class="text">{{details?.EmployeeName}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.EmployeeLocationReq === true) {
        <div>
            <div class="text">{{details?.EmployeeLocation}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.EmployeeSSNReq === true) {
        <div>
            <div class="text">{{details?.EmployeeSSN}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.StoreLocationNumberReq === true) {
        <div>
            <div class="text">{{details?.StoreLocationNumber}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.AccountNameReq === true) {
        <div>
            <div class="text">{{details?.AccountName}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.AccountNumberReq === true) {
        <div>
            <div class="text">{{details?.AccountNumber}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.ParentNameReq === true) {
        <div>
            <div class="text">{{details?.ParentName}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.ParentSSNReq === true) {
        <div>
            <div class="text">{{details?.ParentSSN}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.ParentOrganizationReq === true) {
        <div>
            <div class="text">{{details?.ParentOrganization}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.ParentDepartmentReq === true) {
        <div>
            <div class="text">{{details?.ParentDepartment}}</div>
            <mat-form-field class="w-full"><input matInput></mat-form-field>
        </div>
        }
        @if (details?.ScholarshipEssayReq === true) {
        <div>
            <div class="text">{{details?.ScholarshipEssay}}</div>
            <mat-form-field class="w-full"><textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="8"></textarea></mat-form-field>
        </div>
        }
        @if (details?.ScholarshipEssay2Req === true) {
        <div>
            <div class="text">{{details?.ScholarshipEssay2}}</div>
            <mat-form-field class="w-full"><textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="8"></textarea></mat-form-field>
        </div>
        }
    </mat-card>

    <button mat-raised-button type="button" routerLink="/scholarship-list">Back</button>
</div>